import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ChipsFilterService } from '@models';
import { StudyFilterService } from '@services';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'chips-list',
  templateUrl: './chips-list.component.html',
  styleUrls: ['./chips-list.component.scss']
})
export class ChipsListComponent implements OnInit, OnDestroy {
  @Input() filterService: ChipsFilterService = inject(StudyFilterService);
  @Input() displayedColumns: string[] = [
    'therapeuticArea',
    'studyPhase',
    'studyStage',
    'accelerator',
    'nextMilestone',
    'indication',
    'drugName',
    'studyStatus',
    'fspIndicator'
  ];

  chipsList: Record<string, string[]> = {};
  objectKeys = Object.keys;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.filterService.filterState$.pipe(takeUntil(this.destroy$)).subscribe((filterState) => {
      this.chipsList = {};
      const appliedFilters = filterState.appliedFilters;

      const columnsToProcess = this.isStudyFilterService()
        ? this.displayedColumns
        : Object.keys(appliedFilters);

      this.processFilterColumns(appliedFilters, columnsToProcess);
    });
  }

  removeFilter(column: string, value: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.filterService.removeFilter(column, value);
  }

  private processFilterColumns(
    appliedFilters: Record<string, Set<string>>,
    columns: string[]
  ): void {
    for (const column of columns) {
      if (appliedFilters[column] && appliedFilters[column].size > 0) {
        this.chipsList[column] = Array.from(appliedFilters[column]);
      }
    }
  }

  private isStudyFilterService(): boolean {
    return this.filterService instanceof StudyFilterService;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
